"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tooltip = _interopRequireDefault(require("./Tooltip"));

var _colors = require("./colors");

var _SimpleDate = _interopRequireDefault(require("./SimpleDate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var badgeStyle = {
  position: 'absolute',
  fontSize: '10px',
  top: '-4px',
  left: '12px',
  borderRadius: '50%',
  padding: '1px 4px',
  backgroundColor: _colors.danger.base,
  color: 'white'
};

var Notifications =
/*#__PURE__*/
function (_Component) {
  _inherits(Notifications, _Component);

  function Notifications() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Notifications);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Notifications)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      show: false,
      windowHeight: 0
    });

    _defineProperty(_assertThisInitialized(_this), "updateWindowDimensions", function () {
      _this.setState({
        windowHeight: window.innerHeight
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.props.onClose && _this.props.onClose();

      _this.setState({
        show: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpen", function () {
      _this.props.onOpen && _this.props.onOpen();

      if (_this.props.showNotificationsOnClick) {
        _this.setState({
          show: true
        });
      }
    });

    return _this;
  }

  _createClass(Notifications, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          notifications = _this$props.notifications,
          errorMessage = _this$props.errorMessage,
          numberUnread = _this$props.numberUnread,
          snippetLength = _this$props.snippetLength,
          readMoreComponent = _this$props.readMoreComponent,
          noNotificationsText = _this$props.noNotificationsText,
          dateTimeComponent = _this$props.dateTimeComponent,
          viewAllComponent = _this$props.viewAllComponent,
          constraints = _this$props.constraints;

      var formattedNotifications = _react["default"].createElement("div", null, notifications.map(function (notification, idx) {
        var tooLong = snippetLength ? notification.message.length > snippetLength : false;
        var message = tooLong ? notification.message.split(' ').slice(0, snippetLength / 5).join(' ') + '... ' : notification.message;
        var link = tooLong && readMoreComponent ? readMoreComponent({
          date: notification.timestamp
        }) : null;
        return _react["default"].createElement("div", {
          key: idx // eslint-disable-line react/no-array-index-key

        }, _react["default"].createElement("div", {
          className: "h6",
          style: {
            color: _colors.slate
          }
        }, dateTimeComponent({
          date: notification.timestamp
        })), _react["default"].createElement("div", null, message, link && _react["default"].createElement("span", {
          onClick: _this2.handleClose
        }, link)));
      }));

      var error = _react["default"].createElement("b", {
        className: "text-danger"
      }, _react["default"].createElement("i", {
        className: "fa fa-exclamation-triangle"
      }), " ", errorMessage);

      var popoverContents = _react["default"].createElement("div", {
        style: {
          maxHeight: this.state.windowHeight
        }
      }, _react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          width: '246px'
        }
      }, _react["default"].createElement("h5", null, "Notifications"), viewAllComponent && _react["default"].createElement("div", {
        onClick: this.handleClose
      }, viewAllComponent)), _react["default"].createElement("div", {
        style: {
          maxHeight: this.state.windowHeight - 30,
          overflowY: 'auto'
        }
      }, notifications.length ? formattedNotifications : errorMessage ? error : noNotificationsText));

      return _react["default"].createElement(_Tooltip["default"], {
        direction: "bottom",
        contents: popoverContents,
        show: this.state.show,
        onClickOutside: function onClickOutside() {
          return _this2.state.show && _this2.handleClose();
        },
        variety: "popover",
        constraints: constraints,
        style: {
          margin: '0 8px 0 0'
        }
      }, _react["default"].createElement("span", {
        onClick: function onClick() {
          return _this2.state.show ? _this2.handleClose() : _this2.handleOpen();
        },
        className: "clickable",
        style: {
          position: 'relative',
          height: '22px',
          width: '25px'
        }
      }, _react["default"].createElement("i", {
        className: "fa fa-bell-o fa-lg",
        style: {
          padding: '4px 0'
        }
      }), numberUnread > 0 && _react["default"].createElement("span", {
        style: badgeStyle
      }, numberUnread)));
    }
  }]);

  return Notifications;
}(_react.Component);

exports["default"] = Notifications;
Notifications.propTypes = {
  notifications: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    message: _propTypes["default"].string.isRequired,
    timestamp: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired
  })),
  errorMessage: _propTypes["default"].string,
  numberUnread: _propTypes["default"].number,
  snippetLength: _propTypes["default"].number,
  readMoreComponent: _propTypes["default"].func,
  viewAllComponent: _propTypes["default"].node,
  dateTimeComponent: _propTypes["default"].func,
  noNotificationsText: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  constraints: _propTypes["default"].arrayOf(_propTypes["default"].object),
  showNotificationsOnClick: _propTypes["default"].bool
};
Notifications.defaultProps = {
  notifications: [],
  noNotificationsText: 'No unread notifications',
  snippetLength: 0,
  numberUnread: 0,
  dateTimeComponent: function dateTimeComponent(_ref) {
    var date = _ref.date;
    return _react["default"].createElement(_SimpleDate["default"], {
      date: date
    });
  },
  // eslint-disable-line react/prop-types
  constraints: [{
    to: 'scrollParent',
    attachment: 'bottom',
    pin: ['left', 'right']
  }],
  showNotificationsOnClick: true
};